import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "cart-item"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1,
  class: "radio"
};
const _hoisted_4 = {
  key: 0,
  class: "off-the-shelves-title"
};
const _hoisted_5 = {
  key: 1,
  class: "out-of-stock-title"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "cart-selected-spu"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "cart-town-price"
};
const _hoisted_12 = {
  key: 0,
  class: "deal-price-type"
};
const _hoisted_13 = {
  key: 1,
  class: "deal-price-type"
};
const _hoisted_14 = {
  class: "cart-price"
};
const _hoisted_15 = {
  class: "price-unit"
};
const _hoisted_16 = {
  class: "price-int"
};
const _hoisted_17 = {
  class: "price-decimal"
};
const _hoisted_18 = {
  key: 2,
  class: "cart-time-down"
};
const _hoisted_19 = {
  key: 3,
  class: "cart-descend"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  key: 0,
  class: "cart-free-mail-reminder"
};
const _hoisted_22 = {
  class: "goods-slide-right"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = ["src"];
import { computed, ref, watch } from 'vue';
import constants from '@/constants';
import { useLess } from '@/models/hooks';
import imageLink from '@/configs/imageLink';
import CountDown from '@/components/countDown/CountDown.vue';
import { getDealCountDownTimeInMillis, priceSplice, imageCutEdgeAndSetSize } from '@/utils/common';
const MAX_STOCKS_NUMBER = 20;
export default {
  __name: 'CartItem',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {
        return {
          count: 0,
          asin: '',
          merchantId: '',
          ourPrice: 0,
          stocks: 0,
          title: '',
          mainImageUrl: '',
          availability: null,
          gsBadge: '',
          twisterDisplayString: '',
          delivery: {
            isGlobalStoreFreeShippingProgram: false // Postage is free over 300
          },

          dealOffer: null,
          newOurPrice: 0,
          check: false,
          isFavorite: false,
          selectionEligible: true,
          // true: Not taken off the shelf, false: It's already taken off the shelf
          isAutoQuota: false // Whether to restrict purchase
        };
      }
    },

    couponList: {
      type: Object,
      default: () => {
        return [];
      }
    },
    isManagement: {
      type: Boolean,
      required: false,
      default: () => false
    },
    asinStocksReminder: {
      type: Number,
      required: false
    }
  },
  emits: ['updateCount', 'updateCheck', 'onSelectProduct', 'onDeleteItem', 'onAddToFavorite', 'onToDetail', 'onShareItem',
  // 'onRemoveFavorite', todo
  'onCountDownFinish'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('views/cart/components/CartItem.less');
    const {
      DELETE,
      SELECTED,
      SHARE_WHITE,
      NOT_SELECTED,
      RIGHT_ARROW_BLACK,
      PRICE_REDUCTION_ICON
    } = imageLink;
    const {
      AVAILABILITY_STATUS,
      DEAL_TYPES
    } = constants.Common;

    // The quantity limit for each ASIN added to the new demand is 20
    // Current front-end write dead
    // Retrieve from backend configuration in the future

    const productCount = ref(props.item.count);
    const check = ref(props.item.check);
    const buttonRef = ref();
    watch(() => props.item.check, value => {
      check.value = value;
    });
    watch(() => props.item.count, value => {
      productCount.value = value;
    });
    // Modified quantity
    const onChange = count => {
      emit('updateCount', {
        count,
        asin: props.item.asin
      });
    };
    // Modify selected status
    const onCheckChange = value => {
      emit('updateCheck', {
        asin: props.item.asin,
        value
      });
    };
    // delete
    const onDeleteItem = asin => {
      emit('onDeleteItem', asin);
    };
    // todo
    // Move to collection
    // const onAddFavorite = () => {
    //   emit('onAddToFavorite', {
    //     asin: props.item.asin,
    //     merchantId: props.item.merchantId
    //   });
    // };
    // const onRemoveFavorite = () => {
    //   emit('onRemoveFavorite', {
    //     asin: props.item.asin
    //   });
    // };
    // Determine if it is out of stock
    const isOutOfStock = () => {
      var _props$item$availabil;
      return ((_props$item$availabil = props.item.availability) === null || _props$item$availabil === void 0 ? void 0 : _props$item$availabil.status) === AVAILABILITY_STATUS.OUT_OF_STOCK;
    };
    const cptAsinRightSwipeWidth = computed(() => {
      var _buttonRef$value;
      // Count is equal to the number of buttons in the side sliding area
      // Up to three buttons
      let count = 1;
      if (props.item.selectionEligible && !isOutOfStock()) {
        count = 2;
      } else if (isOutOfStock()) {
        count = 1;
      }
      let deleteButtonWidth = 0;
      if ((_buttonRef$value = buttonRef.value) !== null && _buttonRef$value !== void 0 && _buttonRef$value.clientWidth) {
        var _buttonRef$value2;
        deleteButtonWidth = (_buttonRef$value2 = buttonRef.value) === null || _buttonRef$value2 === void 0 ? void 0 : _buttonRef$value2.clientWidth;
      } else {
        if (document.getElementsByClassName('cart-item-delete-button')[0]) {
          deleteButtonWidth = parseFloat(window.getComputedStyle(document.getElementsByClassName('cart-item-delete-button')[0], null).getPropertyValue('width'));
        }
      }
      // 6 is the width of the overlay area
      return deleteButtonWidth * count - (count - 1) * 6 || 0;
    });
    // Add shopping cart
    const onAddCart = isReplace => {
      emit('onSelectProduct', {
        asin: props.item.asin,
        merchantId: props.item.merchantId,
        count: isReplace ? props.item.count : 1,
        isReplace
      });
    };
    // on Share
    const onShare = () => {
      emit('onShareItem', props.item);
    };
    const onToDetail = item => {
      if (isOutOfStock() || !item.selectionEligible) {
        return;
      }
      emit('onToDetail', props.item.asin);
    };
    const countDownFinish = () => {
      emit('onCountDownFinish', props.item.asin);
    };
    const stocksQuantity = stocks => {
      return stocks > MAX_STOCKS_NUMBER ? MAX_STOCKS_NUMBER : stocks;
    };
    return (_ctx, _cache) => {
      const _component_van_checkbox = _resolveComponent("van-checkbox");
      const _component_van_stepper = _resolveComponent("van-stepper");
      const _component_van_swipe_cell = _resolveComponent("van-swipe-cell");
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createBlock(_component_van_swipe_cell, {
        "right-width": cptAsinRightSwipeWidth.value
      }, {
        right: _withCtx(() => [_createElementVNode("div", _hoisted_22, [__props.item.selectionEligible ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [!isOutOfStock() ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "a-button share",
          onClick: onShare
        }, [_createElementVNode("img", {
          src: _unref(SHARE_WHITE),
          alt: ""
        }, null, 8, _hoisted_23), _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.share')), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "a-button delete cart-item-delete-button",
          onClick: _cache[11] || (_cache[11] = $event => onDeleteItem(__props.item.asin)),
          ref_key: "buttonRef",
          ref: buttonRef
        }, [_createElementVNode("img", {
          src: _unref(DELETE),
          alt: ""
        }, null, 8, _hoisted_24), _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.delete')), 1)], 512)])]),
        default: _withCtx(() => {
          var _props$item$dealOffe, _props$item$dealOffe2, _props$item$delivery;
          return [_createElementVNode("div", _hoisted_1, [!isOutOfStock() && __props.item.selectionEligible || __props.isManagement ? (_openBlock(), _createBlock(_component_van_checkbox, {
            key: 0,
            class: "radio",
            modelValue: check.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => check.value = $event),
            "checked-color": "#eb1745",
            onChange: onCheckChange
          }, {
            icon: _withCtx(checkboxProps => [_createElementVNode("img", {
              src: checkboxProps.checked ? _unref(SELECTED) : _unref(NOT_SELECTED)
            }, null, 8, _hoisted_2)]),
            _: 1
          }, 8, ["modelValue"])) : (_openBlock(), _createElementBlock("div", _hoisted_3)), _createElementVNode("div", {
            class: _normalizeClass(["cart-product-image", {
              'out-of-stock': isOutOfStock(),
              'off-the-shelves': !__props.item.selectionEligible
            }]),
            onClick: _cache[1] || (_cache[1] = $event => onToDetail(__props.item))
          }, [_withDirectives(_createElementVNode("img", null, null, 512), [[_directive_lazy, _unref(imageCutEdgeAndSetSize)(__props.item.mainImageUrl)]]), !__props.item.selectionEligible ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('common.OFF_THE_SHELVES')), 1)) : isOutOfStock() ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('common.OUT_OF_STOCK')), 1)) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
            class: "cart-product-detail",
            onClick: _cache[10] || (_cache[10] = $event => onToDetail(__props.item))
          }, [_createElementVNode("p", null, _toDisplayString(__props.item.title), 1), _createElementVNode("div", {
            class: "cart-product-tag",
            onClick: _cache[2] || (_cache[2] = $event => onToDetail(__props.item))
          }, [__props.item.gsBadge ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.item.gsBadge.badgeURL,
            alt: ""
          }, null, 8, _hoisted_6)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.couponList, (promotion, index) => {
            return _openBlock(), _createElementBlock(_Fragment, null, [Object.keys(promotion || {}).length && !isOutOfStock() && __props.item.selectionEligible ? (_openBlock(), _createElementBlock("span", {
              key: index
            }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('common.DISCOUNT_THREE_HUNDRED_MINUS_TWENTY', {
              amount: promotion.thresholdAmount,
              promotion: promotion.benefitsAmount
            })), 1)])) : _createCommentVNode("", true)], 64);
          }), 256))]), __props.item.selectionEligible && !isOutOfStock() ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_7, [__props.item.twisterDisplayString ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("span", {
            onClick: _cache[3] || (_cache[3] = _withModifiers($event => onAddCart(true), ["stop"]))
          }, _toDisplayString(_ctx.$t('common.selected')), 1), _createElementVNode("span", {
            onClick: _cache[4] || (_cache[4] = _withModifiers($event => onAddCart(true), ["stop"]))
          }, _toDisplayString(__props.item.twisterDisplayString), 1), _createElementVNode("img", {
            onClick: _cache[5] || (_cache[5] = _withModifiers($event => onAddCart(true), ["stop"])),
            class: "cart-right-arrow",
            src: _unref(RIGHT_ARROW_BLACK),
            alt: ""
          }, null, 8, _hoisted_8)], 64)) : _createCommentVNode("", true), _createVNode(_component_van_stepper, {
            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop", "prevent"])),
            modelValue: productCount.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => productCount.value = $event),
            theme: "round",
            "disable-input": "",
            onChange: onChange,
            max: stocksQuantity(__props.item.stocks)
          }, null, 8, ["modelValue", "max"]), __props.asinStocksReminder && stocksQuantity(__props.item.stocks) <= __props.asinStocksReminder ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["low-stocks-reminder", __props.item.twisterDisplayString ? 'have-select' : 'not-select']),
            innerHTML: _ctx.$t('modules.checkout.ONLY_X_ITEMS_LEFT_PRE_ORDER_QUICKLY_BR', {
              TOTAL: stocksQuantity(__props.item.stocks)
            })
          }, null, 10, _hoisted_9)) : _createCommentVNode("", true)]), _createElementVNode("div", {
            onClick: _cache[9] || (_cache[9] = _withModifiers($event => onToDetail(__props.item), ["stop"]))
          }, [_createElementVNode("span", {
            class: "cart-another-one",
            onClick: _cache[8] || (_cache[8] = _withModifiers($event => onAddCart(false), ["stop"]))
          }, [_createTextVNode(_toDisplayString(_ctx.$t('common.pickAnotherOne')) + " ", 1), _createElementVNode("img", {
            class: "cart-right-arrow",
            src: _unref(RIGHT_ARROW_BLACK),
            alt: ""
          }, null, 8, _hoisted_10)])]), _createElementVNode("div", _hoisted_11, [__props.item.dealOffer && __props.item.dealOffer.dealType === _unref(DEAL_TYPES)['DEAL_OF_THE_DAY'] ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('common.DOTDPrice')), 1)) : __props.item.dealOffer && __props.item.dealOffer.dealType === _unref(DEAL_TYPES)['BEST_DEAL'] ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('common.specialSalePrice')), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('common.currencyUnit')), 1), _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(priceSplice)(__props.item.newOurPrice || __props.item.ourPrice)[0]), 1), _createElementVNode("span", _hoisted_17, " ." + _toDisplayString(_unref(priceSplice)(__props.item.newOurPrice || __props.item.ourPrice)[1]), 1)]), _unref(getDealCountDownTimeInMillis)((_props$item$dealOffe = __props.item.dealOffer) === null || _props$item$dealOffe === void 0 ? void 0 : _props$item$dealOffe.endTime) !== null ? (_openBlock(), _createElementBlock("span", _hoisted_18, [_createTextVNode(_toDisplayString(_ctx.$t('common.timeRemaining')) + " ", 1), _createVNode(CountDown, {
            time: _unref(getDealCountDownTimeInMillis)((_props$item$dealOffe2 = __props.item.dealOffer) === null || _props$item$dealOffe2 === void 0 ? void 0 : _props$item$dealOffe2.endTime),
            onFinish: countDownFinish
          }, null, 8, ["time"])])) : _createCommentVNode("", true), __props.item.newOurPrice < __props.item.ourPrice ? (_openBlock(), _createElementBlock("span", _hoisted_19, [_createElementVNode("img", {
            src: _unref(PRICE_REDUCTION_ICON),
            alt: ""
          }, null, 8, _hoisted_20), _createTextVNode(" " + _toDisplayString(_ctx.$t('common.priceDroppedBy') + _ctx.$t('common.currencyUnit') + (__props.item.ourPrice - __props.item.newOurPrice).toFixed(2) + _ctx.$t('common.sinceCartAdd')), 1)])) : _createCommentVNode("", true)]), !((_props$item$delivery = __props.item.delivery) !== null && _props$item$delivery !== void 0 && _props$item$delivery.isGlobalStoreFreeShippingProgram) ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.$t('common.thisItemNotInFreeShippingActivity')), 1)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])])];
        }),
        _: 1
      }, 8, ["right-width"]);
    };
  }
};